export default __webpack_public_path__ + "static/media/nikoleta-headshot.0490b33a.png";